<template>
    <div>
        <b-card no-body class="mb-1">
            <b-overlay :show="getting" opacity="0.2">
                <div class="p-1">
                    <div class="row align-items-center">
                            <div class="col-md-3 mb-1 mb-md-0">             
                                <b-input-group class="input-group-merge">
                                    <template #prepend>
                                        <b-input-group-text >
                                            <feather-icon icon="SearchIcon"></feather-icon>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input placeholder="Ara..." v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                                </b-input-group>
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-success" v-on:click="getData">Sorgula</button>
                            </div>
                            <div class="col-md-auto ml-auto">
                                <b-dropdown  :disabled="acting" right variant="primary" >
                                    <template #button-content>
                                        <b-spinner v-if="acting" small/>
                                        <template v-else>İşlemler</template>
                                    </template>
                                    <b-dropdown-item v-if="excelPath" v-on:click="downloadExcel">Excel İndir</b-dropdown-item>
                                    <b-dropdown-item v-on:click="approve">Onayla</b-dropdown-item>
                                    <b-dropdown-item v-on:click="lock">Kilitle</b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-sm bordered-header">
                        <!-- <thead>
                            +
                            <tr>
                                <th colspan="14"></th>
                                <th colspan="12" class="bg-light-secondary">Prim</th>
                                <th colspan="12"></th>
                            </tr>
                            <tr>
                                <th class="text-nowrap text-center">Sıra</th>
                                <th class="text-nowrap">TC</th>
                                <th class="text-nowrap">IBAN</th>
                                <th class="text-nowrap">SGK Şube</th>
                                <th class="text-nowrap text-right">Maaş [Baz]</th>
                                <th class="text-nowrap">Giriş Tarihi</th>
                                <th class="text-nowrap">Çıkış Tarihi</th>
                                <th class="text-nowrap">YİGS [Yıllık İzin Gün Sayısı]</th>
                                <th class="text-nowrap text-right">İİGS [İdari İzin Gün Sayısı]</th>
                                <th class="text-nowrap text-right">ÜTOGS [Ücrete Tabi Olmayan Gün Sayısı]</th>
                                <th class="text-nowrap text-right">Maaş [Baz Fiili]</th>
                                <th class="text-nowrap">Agi</th>
                                <th class="text-nowrap text-right">Toplam Maaş</th>
                                <th class="text-nowrap text-right">YİÜ [Yıllık İzin Ücreti]</th>

                                <th class="text-secondary text-nowrap text-right">FMÜ [Fazla Mesai Ücreti]</th>
                                <th class="text-secondary text-nowrap text-right">Yemek Yardımı</th>
                                <th class="text-secondary text-nowrap text-right">Yol Yardımı</th>
                                <th class="text-secondary text-nowrap text-right">Prim [Toplam]</th>
                                <th class="text-secondary text-nowrap text-right">Destek Primi</th>
                                <th class="text-secondary text-nowrap text-right">Hammaliye Bedeli</th>
                                <th class="text-secondary text-nowrap text-right">Yatma</th>
                                <th class="text-secondary text-nowrap text-right">Mazot Primi</th>
                                <th class="text-secondary text-nowrap text-right">Dengeleyici Ücret</th>
                                <th class="text-secondary text-nowrap text-right">Bayram Mesaisi</th>
                                <th class="text-secondary text-nowrap text-right">ODÖ [Olağandışı Ödemeler]</th>
                                <th class="text-secondary text-nowrap">Açıklama</th>

                                <th class="text-nowrap text-right">Toplam Hakediş</th>
                                <th class="text-nowrap text-right">Önceki Ay Toplam Hakediş</th>
                                <th class="text-nowrap text-right">Ödeme [Banka 1]</th>
                                <th class="text-nowrap text-right">İcra</th>
                                <th class="text-nowrap text-right">BES</th>
                                <th class="text-nowrap text-right">Avans [Banka 1]</th>
                                <th class="text-nowrap text-right">Trafik Ceza</th>
                                <th class="text-nowrap text-right">Ticket Hariç Resmi Toplam</th>
                                <th class="text-nowrap text-right">Ticket</th>
                                <th class="text-nowrap text-right">Ticket Üst Limit</th>
                                <th class="text-nowrap text-right">Ticket Dahil Resmi Toplam</th>
                                <th class="text-nowrap text-right">Elden Ödenecek</th>
                            </tr>
                        </thead> -->
                        <thead>
                            <tr>
                                <th>Onaylı</th>
                                <th>Kilitli</th>
                                <th class="w-50">Personel</th>
                                <th class="w-50 text-right">Banka 2</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(d,i) in (datas || [])" :class="{'bg-light-danger':d.Amount < 0}">
                                <td class="text-center">
                                    <span v-if="$safe(d,'Confirmed')" class="material-icons-outlined d-block text-success">check_circle</span>
                                    <span v-else class="material-icons-outlined d-block text-danger">cancel</span>
                                </td>
                                <td class="text-center">
                                    <span v-if="$safe(d,'Locked')" class="material-icons-outlined d-block text-success">check_circle</span>
                                    <span v-else class="material-icons-outlined d-block text-danger">cancel</span>
                                </td>
                                <td>{{ $safe(d,'EmployeeFullName') }}</td>
                                <td class="text-right">{{ $safe(d,'AmountStr') }}</td>
                            </tr>
                            <tr v-if="(datas || []).length == 0">
                                <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="mx-75 mb-1" v-if="count > 0">
                    <div class="row justify-content-md-between justify-content-center">
                        <div class="col-auto mb-1 mb-md-0">
                            <div class="d-flex align-items-center text-nowrap">
                                Toplam {{(count || 0)}} kayıt arasından
                                <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                                    <option v-for="pp in perPages" :key="pp" :value="pp">{{pp}}</option>
                                </select>
                                gösteriliyor.   
                            </div>
                        </div>
                        <div class="col-auto mb-1 mb-md-0">
                            <b-pagination class="mb-0" v-model="page" :total-rows="((count || 0))" :per-page="perPage"></b-pagination>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BDropdown, BDropdownItem, BInputGroup, BInputGroupText, BFormInput,BOverlay, BPagination, BSpinner } from 'bootstrap-vue';
import EmployeeOperationsApi from '@/api/employee-operations'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard,
        BDropdown, 
        BDropdownItem, 
        BInputGroup, 
        BInputGroupText, 
        BFormInput,
        BOverlay,
        BPagination,
        BSpinner
    },
    props:{
        donem:{
            type:Object,
            default:()=>({
                year:null,
                month:null
            })
        },
        filter:{
            type:Object,
            default:() => ({})
        },
    },
    watch:{
        "page"(oldV,newV){
            if(oldV && newV && oldV != newV){
                this.getData()
            }
        },
        "perPage"(oldV,newV){
            if(oldV && newV && oldV != newV){
                this.getData()
            }
        }
    },
    data(){
        return {
            page:1,
            perPage:10,
            perPages:[10,20,30,40,50,100],
            searchValue:'',
            datas:[],
            count:0,
            getting:false,
            tableResult:null,
            excelPath:null,
            acting:false
        }
    },
    methods:{
        getData(){
            this.getting = true
            EmployeeOperationsApi.GSalary.ConfirmationStep({
                ...this.filter,
                PaginateRequest:{
                    IsAscending:true,
                    OrderColumnName:'FullName',
                    QueryParam:this.searchValue,
                    Skip:this.page,
                    Take:this.perPage
                }
            }).then(res => {
                if(res.data.Success){
                    this.tableResult = null
                    this.datas = res.data.Data.Data.Data || []
                    this.count = res.data.Data.Data.TotalCount || 0
                    this.excelPath = res.data.Data.ExcelPath || null
                }
                this.getting =false
            }).catch(err =>{
                this.$result(null,err)
                this.getting = false
            })
        },
        lock(){
            this.$confirm('Tüm maaşları kilitlemek istediğinize emin misiniz?','Bu işlem tüm personeller için maaşları kilitler ve geri alınamaz.').then(c => {
                if(c){
                    this.acting = true
                    EmployeeOperationsApi.LucaResult.LockG({
                        ...this.filter,
                        Lock:true,
                        PaginateRequest:{
                            IsAscending:true,
                            OrderColumnName:'FullName',
                            QueryParam:this.searchValue,
                            Skip:this.page,
                            Take:this.perPage
                        }
                    }).then(res => {
                        if(res.data.Success){
                            this.getData()
                        }
                        this.$result(res)
                        this.acting = false
                    }).catch(err => {
                        this.$result(null,err)
                        this.acting = false
                    })
                }
            })
        },
        approve(){
            this.$confirm('Tüm maaşları onaylamak istediğinize emin misiniz?','Bu işlem tüm personeller için maaşları onaylar ve geri alınamaz.').then(c => {
                if(c){
                    this.acting = true
                    EmployeeOperationsApi.LucaResult.ConfirmG({
                        ...this.filter,
                        PaginateRequest:{
                            IsAscending:true,
                            OrderColumnName:'FullName',
                            QueryParam:this.searchValue,
                            Skip:this.page,
                            Take:this.perPage
                        }
                    }).then(res => {
                        if(res.data.Success){
                            this.getData(false)
                        }
                        this.$result(res)
                        this.acting = false
                    }).catch(err => {
                        this.$result(null,err)
                        this.acting = false
                    })
                }
            })
        },
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        }
    }
}
</script>

